export const LOANS_STRESS_REPORT_NOTIFICATION_ID = "d-d056ae3dd82049b19e5e9c402eeb985c"
export const DEAL_STATUS_CHANGE_NOTIFICATION_ID = "d-e66271d174cc455fa49b26f4819696a8"
export const ASSETS_LIST_EXPORT_NOTIFICATION_ID = "d-c3ed17db6b9149998f281ce808cad694"
export const NOTIFICATION_MARGIN_TOP = 64
